// ============================
// AETHRIX CUSTOM SCRIPTS
// ============================

// Scroll-triggered header
(function() {
  const header = document.querySelector('.header');
  if (!header) return;
  window.addEventListener('scroll', function() {
    header.classList.toggle('scrolled', window.scrollY > 50);
  }, { passive: true });
})();

// Fade-in on scroll (intersection observer)
(function() {
  const targets = document.querySelectorAll('.card-wrapper, .usp-strip__item, .testimonial-card');
  if (!targets.length) return;

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  targets.forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    observer.observe(el);
  });
})();